import { render, staticRenderFns } from "./AddOrderNotFOBDialog.vue?vue&type=template&id=0922cb8c&"
import script from "./AddOrderNotFOBDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrderNotFOBDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports